import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { EDUCATION_LEVEL_LABEL_KEYS, EducationLevelEnum } from '@digilize/shared/definitions/src';

@Component({
  selector: 'bwh-lib-skills-edition',
  templateUrl: './skills-edition.component.html',
  styleUrls: ['./skills-edition.component.scss'],
})
export class SkillsEditionComponent implements OnInit {
  @Input() title: string;
  @Input() form: FormGroup;
  @Input() control: string;
  @Input() editButton = true;
  @Input() cvSharing = false;
  @Input() blockStarClick = false;
  @Input() blockGoToEditionBtn = false;
  @Input() additionalBtnInfo: string;
  @Input() editName: string;
  @Input() infoTxt: string;
  @Input() buttonTxt: string;
  @Input() levelOptions: any;
  @Input() showHeader = true;
  @Input() inlineEditing = false;
  @Input() maxDisplay = 0;
  @Input() sortEnabled = false;
  @Input() sortThreshold = 10;
  @Input() reordering = false;
  @Input() separatorAfterIndex = -1;

  @Output() clickEdit = new EventEmitter();
  @Output() addingExp = new EventEmitter();
  @Output() ratingChanged = new EventEmitter();
  @Output() deleteSkill = new EventEmitter<number>();
  @Output() sortClicked = new EventEmitter<string>();
  @Output() reorderingChange = new EventEmitter<boolean>();
  @Output() reordered = new EventEmitter<void>();

  stars = [0, 1, 2, 3, 4];
  showAll = false;

  constructor() {}
  ngOnInit(): void {}

  get formArray() {
    return this.form.get(this.control) as FormArray;
  }

  get displayedSkills(): any[] {
    const all = this.formArray?.value ?? [];
    if ((this.showAll || this.reordering) && all.length > 0) {
      return all;
    }
    if (this.maxDisplay > 0 && all.length > this.maxDisplay) {
      return all.slice(0, this.maxDisplay);
    }
    return all;
  }

  get overflowCount(): number {
    const all = this.formArray?.value ?? [];
    if (this.maxDisplay > 0 && all.length > this.maxDisplay) {
      return all.length - this.maxDisplay;
    }
    return 0;
  }

  toggleShowAll(): void {
    this.showAll = !this.showAll;
  }

  toggleReordering(): void {
    this.reordering = !this.reordering;
    this.reorderingChange.emit(this.reordering);
  }

  drop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) return;

    const controls = [...this.formArray.controls];
    moveItemInArray(controls, event.previousIndex, event.currentIndex);

    while (this.formArray.length) {
      this.formArray.removeAt(0, { emitEvent: false });
    }
    controls.forEach((c) => this.formArray.push(c, { emitEvent: false }));
    this.formArray.updateValueAndValidity();
    this.reordered.emit();
  }

  starClicked(event) {
    if (!this.blockStarClick && !this.cvSharing) {
      const thisSkill = this.formArray.at(event.index);
      thisSkill.get('rating').setValue(event.rating);
      this.ratingChanged.emit(thisSkill.value);
    }
  }

  starClickedWritten(event) {
    if (!this.blockStarClick && !this.cvSharing) {
      const thisSkill = this.formArray.at(event.index);
      thisSkill.get('rating_written').setValue(event.rating);
      this.ratingChanged.emit(thisSkill.value);
    }
  }

  edit() {
    this.clickEdit.emit(this.editName ? this.editName : this.control);
  }

  buttonClick() {
    this.clickEdit.emit(this.editName);
    this.addingExp.emit(true);
  }

  onDeleteSkill(index: number): void {
    this.deleteSkill.emit(index);
  }

  onSortClicked(): void {
    this.toggleReordering();
    this.sortClicked.emit(this.control);
  }

  getEducationLevelLabelKey(level: number | string | null | undefined): string | null {
    if (level === null || level === undefined || level === '') return null;
    const key = EDUCATION_LEVEL_LABEL_KEYS[Number(level) as EducationLevelEnum];
    return key ?? null;
  }
}
